/**
 * The `ch-tabular-grid-rowset-empty` component represents a container to "empty message" when ch-tabular-grid-rowset is empty.
 */
export class ChTabularGridRowsetEmpty {
    static get is() { return "ch-tabular-grid-rowset-empty"; }
    static get originalStyleUrls() {
        return {
            "$": ["tabular-grid-rowset-empty.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabular-grid-rowset-empty.css"]
        };
    }
}
